import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Subscription} from 'rxjs/Subscription';
import {ToastrService} from 'ngx-toastr';
import {UsageReportService} from '../../views/oes/services/usage-report.service';
import { Chart } from 'angular-highcharts';
import {PlotLines} from 'highcharts';

@Component({
    selector: 'app-import-master-data-modal',
    templateUrl: './app-part-usage-time-series.component.html',
    styleUrls: [],
    preserveWhitespaces: true,
    providers: [
        UsageReportService
    ]
})
export class AppPartUsageTimeSeriesComponent implements OnInit, OnDestroy {

    @ViewChild('timeSeriesModal') timeSeriesModal: ElementRef;
    @ViewChild('header') header: ElementRef;
    @ViewChild('content') content: ElementRef;
    @ViewChild('footer') footer: ElementRef;

    public part: any;
    public bins: string;
    public loading = true;
    public chart: Chart;

    private subscription: Subscription;

    public dataSourceOptions = this.usageReportService.getDataSourceOptions(true, true);

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<AppPartUsageTimeSeriesComponent>,
        private usageReportService: UsageReportService,
        private toast: ToastrService
    ) { }

    ngOnInit() {
        this.loading = true;
        this.part = {
            MD1_ID: 0,
            ITEM_ID: '',
            RA1_SHIP_TO_ID: '',
            RA1_SHIP_TO_NAME: '',
            MD1_ITEM_DESC: '',
            MD1_CREATED_ON: '',
            MD1_MIN_QTY: 0,
            MD1_MAX_QTY: 0
        };
        this.bins = '';

        this.subscription = this.usageReportService.getPartUsageTimeSeries(this.data).subscribe(result => {
            if (result.success) {
                // generate highcharts
                this.part = result.part;
                this.bins = result.bins;
                this.generateTimeSeriesChart(result.timeSeries, result.part);
            } else {
                this.toast.error('Failed to load time series for part.', 'Error');
                this.closeDialog(null);
            }
            this.loading = false;
        }, () => {
            this.toast.error('Request timed out.', 'Service Error');
            this.loading = false;
            this.closeDialog(null);
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    closeDialog(value) {
        this.dialogRef.close(value);
    }

    generateTimeSeriesChart(data, part) {
        const categories = [];
        const dataPoints = [];
        let maxY = 0;
        if (this.data.reportCriteria === UsageReportService.REPORT_QTY) {
            maxY = Math.max(Number(part['MD1_MIN_QTY']), Number(part['MD1_MAX_QTY']));
        }
        for (const dataItem of data) {
            categories.push(dataItem['month']);
            dataPoints.push(Number(dataItem['value']));
            maxY = Math.max(maxY, Number(dataItem['value']));
        }
        const reportCriteriaLabel = this.usageReportService.getReportCriteriaLabel( Number(this.data.reportCriteria) );
        const valuePrecision = this.usageReportService.getReportCriteriaValuePrecision( Number(this.data.reportCriteria) );
        const plotLines: Array<PlotLines> = [];
        if (this.data.reportCriteria === UsageReportService.REPORT_HITS) {
            const upper_control_limit=(part['COUNT_BINS']/2)*(part['MD1_BIN_SIZE']/2);
            maxY = Math.max(maxY, upper_control_limit);
            plotLines.push({
                value: upper_control_limit,
                color: 'red',
                width: 2,
                dashStyle: 'solid',
                label: {
                    text: 'Upper Control Limit'
                },
                zIndex: 100
            });
        }
        if (this.data.reportCriteria === UsageReportService.REPORT_QTY) {
            plotLines.push({
                value: Number(part['MD1_MIN_QTY']),
                color: 'orange',
                width: 2,
                dashStyle: 'shortdash',
                label: {
                    text: 'Min Qty'
                },
                zIndex: 100
            });
            plotLines.push({
                value: Number(part['MD1_MAX_QTY']),
                color: 'green',
                width: 2,
                dashStyle: 'shortdash',
                label: {
                    text: 'Max Qty'
                },
                zIndex: 100
            });
        }
        this.chart = new Chart({
            title: {
                text: 'Usage for Item ID - ' + this.part.ITEM_ID,
                style: {
                    fontSize: '15px'
                }
            },
            xAxis: {
                title: {
                    text: 'Month'
                },
                categories: categories
            },
            yAxis: {
                title: {
                    text: reportCriteriaLabel
                },
                min: 0,
                max: maxY,
                plotLines: plotLines
            },
            plotOptions: {
                area: {
                    fillColor: {
                        linearGradient: {
                            x1: 0, y1: 0, x2: 0, y2: 1
                        },
                        stops: [
                            [0, '#FFFFFF'],
                            [1, '#00467f']
                        ]
                    },
                    marker: {
                        radius: 4
                    },
                    lineColor: '#00467f',
                    lineWidth: 1,
                    threshold: null
                }
            },
            tooltip: {
                formatter(): boolean | string {
                    return this.x + '<br>'
                        + '<b>' + reportCriteriaLabel + '</b>: '
                        + (valuePrecision === 2 ? '$' : '') + this.y.toFixed(valuePrecision);
                }
            },
            series: [
                {
                    type: 'area',
                    name: reportCriteriaLabel + ' by month',
                    data: dataPoints
                }
            ]
        });
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-part-usage-time-series/app-part-usage-time-series.component.ts